import { type ReactNode } from 'react';
import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
};

function ForfeitActions(p: Props): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <Button
        variant="ghost"
        size="sm"
        onClick={p.onClose}
        disabled={p.isPending}
      >
        Seguir intentando
      </Button>
      <Button
        variant="danger"
        size="sm"
        onClick={p.onConfirm}
        disabled={p.isPending}
      >
        {p.isPending ? 'Cerrando...' : 'Confirmar salida'}
      </Button>
    </div>
  );
}

// Fase 28: shared forfeit confirmation. Used from the Game Over redemption
// block (before starting) and the in-window /redemption screen (after
// starting). Both paths flip status to banned with no second chance.
export function RedemptionForfeitModal(p: Props): ReactNode {
  return (
    <Modal open={p.open} onClose={p.onClose} title="Salir del juego" size="sm">
      <div className="space-y-base">
        <p className="text-sm leading-relaxed text-text-secondary">
          Si abandonas, tu cuenta queda{' '}
          <strong className="font-semibold text-error">
            cerrada permanentemente
          </strong>
          . No habrá más oportunidades de redención.
        </p>
        <ForfeitActions {...p} />
      </div>
    </Modal>
  );
}
